import { useQuery } from '@apollo/client';
import { GET_COUNTRIES } from '@retainerclub/shared-api';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { FieldContainer } from '../FieldContainer';

function CountrySelect({
  name,
  style = {},
  className = '',
  required = false,
  hideLabel = false,
  autoComplete = 'country',
  usOnly = false,
  auOnly = false,
}) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const { error, loading, data } = useQuery(GET_COUNTRIES, {
    variables: { auOnly },
  });

  return (
    <FieldContainer
      style={style}
      className={className}
      required={required}
      hideLabel={hideLabel}
      name={name}
      label="Country"
    >
      {error || loading ? (
        <div>loading</div>
      ) : (
        <select
          {...register(name)}
          name={name}
          autoComplete={autoComplete}
          className={`block w-full rounded-md border-0 py-1.5 shadow-xs ring-1 ring-inset focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 ${
            errors?.[name]
              ? 'text-red-900 ring-red-300 placeholder:text-red-300 focus:ring-red-500'
              : 'ring-gray-300 placeholder:text-gray-400 focus:ring-rcprimary-400'
          }`}
          disabled={data?.countries === undefined || data?.countries === null}
        >
          <option disabled>Select a Country...</option>
          <option value="US">United States</option>
          {usOnly ? null : <option value="CA">Canada</option>}
          {usOnly
            ? null
            : data?.countries.map((country) => (
                <option key={country.id} value={country.value}>
                  {country.name}
                </option>
              ))}
        </select>
      )}
    </FieldContainer>
  );
}

CountrySelect.propTypes = {
  name: PropTypes.string.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  required: PropTypes.bool,
  hideLabel: PropTypes.bool,
  autoComplete: PropTypes.string,
  auOnly: PropTypes.bool,
  usOnly: PropTypes.bool,
};

export default CountrySelect;
